export default __webpack_public_path__ + "static/media/MROOM_Q4-26.45c55896.jpg";